import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtPlugin({
  name: 'appsflyer-smart-banner',
  setup: () => {
    const router = useRouter();
    const route = useRoute();

    const callAf = (...args: unknown[]): void => {
      if (typeof window.AF !== 'function') {
        return;
      }
      window.AF(...args);
    };

    const applyBannerState = (target: RouteLocationNormalized): void => {
      callAf('banners', 'hideBanner');
      if (!target.meta.hideAppBanners) {
        callAf('banners', 'showBanner');
      }
    };

    if (window.AF_BANNERS_READY) {
      applyBannerState(route);
    } else {
      window.addEventListener('af-banners-ready', () => applyBannerState(route), { once: true });
    }

    router.afterEach(to => {
      if (!window.AF_BANNERS_READY) {
        return;
      }
      applyBannerState(to);
    });
  },
});
